var _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "283.465px",
    height: "283.465px",
    viewBox: "0 0 283.465 283.465",
    enableBackground: "new 0 0 283.465 283.465",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    points: "1477.5,2817.919 1007.369,2378.114 537.233,1938.304 1007.369,1498.488 1477.502,1058.686  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "path",
    fill: "#231F20",
    d: "M1477.461,3006.886c-46.258,0-92.609-16.875-129.055-50.971L408.139,2076.3 c-38.194-35.732-59.872-85.693-59.872-137.996c0-52.302,21.677-102.265,59.871-137.995l470.135-439.816l470.136-439.804 c76.213-71.296,195.795-67.31,267.092,8.904c71.295,76.213,67.309,195.793-8.904,267.089l-792.758,741.62l792.756,741.621 c76.215,71.297,80.199,190.877,8.902,267.09C1578.295,2986.78,1527.935,3006.886,1477.461,3006.886z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    points: "3505.696,2817.919 3975.829,2378.114 4445.964,1938.304 3975.829,1498.488 3505.696,1058.686  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "path",
    fill: "#231F20",
    d: "M3505.733,3006.886c-50.477,0-100.828-20.1-138.035-59.873c-71.295-76.213-67.311-195.793,8.904-267.09 l792.756-741.621l-322.625-301.818l-470.131-439.802c-76.215-71.296-80.199-190.876-8.904-267.09 c71.301-76.213,190.881-80.199,267.092-8.902l470.131,439.803l470.137,439.816c38.197,35.73,59.873,85.693,59.873,137.995 c0,52.303-21.678,102.264-59.873,137.996l-940.268,879.615C3598.349,2990.007,3551.987,3006.886,3505.733,3006.886z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "path",
    fill: "#231F20",
    d: "M2070.881,3316.009c-21.896,0-44.15-3.832-65.875-11.914c-97.811-36.396-147.6-145.191-111.203-243.004 l824.58-2216.059c36.393-97.811,145.186-147.601,243-111.205c97.813,36.395,147.603,145.19,111.208,243.002l-824.583,2216.058 C2219.697,3268.976,2147.562,3316.009,2070.881,3316.009z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    points: " 93.115,88.899 13.409,145.938 94.409,204.272  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    points: " 190.35,204.272 270.056,147.233 189.056,88.899  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    x1: 120.425,
    y1: 216.899,
    x2: 155.091,
    y2: 76.233
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.f0c16e6c3fa6ecacf813aaa4e24115f4.svg";
export { ForwardRef as ReactComponent };